import { AxiosRequestConfig } from "axios";
import { parseISO } from "date-fns";

import { Api } from "./Api";

export const parseDocumentData = (
  documentData: IAxiosResponseData,
): IDocument => {
  /**
   * Parse document data from the API response, to an IDocument object.
   */
  return {
    id: documentData.id,
    originalFilename: documentData.original_filename,
    created: parseISO(documentData.created),
    uploadedBy: documentData.uploaded_by,
  } as IDocument;
};

export const getDocuments = async (
  bagObjectId: string,
): Promise<IDocument[]> => {
  /**
   * Retrieve the documents attached to a BAG object.
   */
  return Api.get(`/bag-objects/${bagObjectId}/documents/`)
    .then((result: IApiSuccess) => {
      const documentsData = result.data as IAxiosResponseData[];
      return documentsData.map((documentData) =>
        parseDocumentData(documentData),
      );
    })
    .catch((error: IApiError) => Promise.reject(error));
};

export const uploadDocument = async (
  bagObjectId: string,
  file: File,
): Promise<void> => {
  /**
   * Upload a document for a BAG object as multipart form data.
   */
  const path = `/bag-objects/${bagObjectId}/documents/`;
  const formData = new FormData();
  formData.append("file", file);
  await Api.post(path, formData);
};

export const downloadDocument = async (
  bagObjectId: string,
  document_: IDocument,
): Promise<void> => {
  /**
   * Download a document via the authenticated API (token header),
   * then hand it to the browser under its original filename.
   */
  const path = `/bag-objects/${bagObjectId}/documents/${document_.id}/download/`;
  const config: AxiosRequestConfig = { responseType: "blob" };
  await Api.get(path, config).then((response: IApiSuccess) => {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(response.data as Blob);
    link.download = document_.originalFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

export const deleteDocument = async (
  bagObjectId: string,
  documentId: string,
): Promise<void> => {
  /**
   * Delete a document of a BAG object.
   */
  await Api.delete(`/bag-objects/${bagObjectId}/documents/${documentId}/`);
};
